import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useLanguage } from '../context/LanguageContext';
import './AuthPages.css';

export default function ResetPasswordPage() {
  const { t } = useLanguage();
  const [password, setPassword]         = useState('');
  const [confirm, setConfirm]           = useState('');
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState('');
  const [success, setSuccess]           = useState(false);
  const [validSession, setValidSession] = useState(false);
  const [checking, setChecking]         = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let resolved = false;

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY' && session) {
        resolved = true;
        setValidSession(true);
        setError('');
        setChecking(false);
      }
    });

    supabase.auth.getSession().then(({ data: { session } }) => {
      if (resolved) return;
      if (session) {
        setValidSession(true);
        setError('');
      } else {
        setError(t('reset.invalidLink'));
      }
      setChecking(false);
    });

    const timer = setTimeout(() => {
      if (!resolved) setChecking(false);
    }, 2500);

    return () => {
      subscription?.unsubscribe();
      clearTimeout(timer);
    };
  }, [t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6)  { setError(t('reset.minLength')); return; }
    if (password !== confirm)  { setError(t('reset.noMatch')); return; }
    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (err) { setError(err.message); return; }
    setSuccess(true);
    setTimeout(() => navigate('/login'), 2500);
  };

  return (
    <div className="auth-page">
      <div className="auth-page__card">
        <Link to="/" className="auth-page__logo" aria-label="CosmoEstates home">
          <img src="/images/logo-transparent.png" alt="CosmoEstates" className="auth-page__logo-img" />
        </Link>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(16,185,129,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h1 className="auth-page__title">{t('reset.success')}</h1>
            <p className="auth-page__sub">{t('reset.successSub')}</p>
          </div>
        ) : (
          <>
            <h1 className="auth-page__title">{t('reset.title')}</h1>
            <p className="auth-page__sub">{t('reset.sub')}</p>
            {error && (
              <div className="auth-page__error">
                {error}
                {!validSession && !checking && (
                  <div style={{ marginTop: 8 }}>
                    <Link to="/forgot-password" style={{ color: '#B8924A', fontWeight: 600 }}>
                      {t('reset.requestNew')}
                    </Link>
                  </div>
                )}
              </div>
            )}
            {validSession && (
              <form onSubmit={handleSubmit} className="auth-page__form">
                <div className="auth-field">
                  <label>{t('reset.newPassword')}</label>
                  <input
                    type="password"
                    placeholder={t('reset.placeholder')}
                    value={password}
                    onChange={e => { setPassword(e.target.value); setError(''); }}
                  />
                </div>
                <div className="auth-field">
                  <label>{t('reset.confirmPassword')}</label>
                  <input
                    type="password"
                    placeholder={t('reset.confirmPlaceholder')}
                    value={confirm}
                    onChange={e => { setConfirm(e.target.value); setError(''); }}
                  />
                </div>
                <button type="submit" className="auth-page__submit" disabled={loading}>
                  {loading ? <span className="auth-page__spinner" /> : t('reset.submit')}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
